import "./SideMenu.scss"
import MenuItems from "./MenuItems"

const SideMenu = () => {
  return (
    <div className="h-full w-full">
      <MenuItems mobile={false} onNav={() => { }} />
    </div>
  )
}

export default SideMenu
